// extracted by mini-css-extract-plugin
export var hidden = "_q0-1";
export var visible = "_q0-0";